export default __webpack_public_path__ + "static/media/sticker-g.5633d1d6.png";